import { gql } from '@apollo/client';

export const COURSES_LIST = gql`
  query courses($count: Int) {
    courses(count: $count) {
      data {
        id
        name
        description
        clinicId
        status
      }
    }
  }
`;
